import React from 'react'
import classes from './AddAttachmentsRPSupportingDocumentButton.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

interface AddAttachmentsRPSupportingDocumentButtonProps {
  openFileDialog: () => void
}

const AddAttachmentsRPSupportingDocumentButton = (
  props: AddAttachmentsRPSupportingDocumentButtonProps
) => {
  return (
    <button
      className={`ul-button -small ${classes['add-attachments-rp-supporting-document-button']}`}
      onClick={props.openFileDialog}
      style={{ borderRadius: '0.25rem' }}
    >
      <FontAwesomeIcon icon={faPlus} size="sm" style={{ paddingRight: '0.25rem' }} />
      Add Supporting Document
    </button>
  )
}

export default AddAttachmentsRPSupportingDocumentButton
